import { TeamDetail } from "@/components/teams/team-detail/index.tsx";
import { m } from "@/paraglide/messages.js";
import { teamQueryOptions } from "@/services/teams-service.ts";
import { createEntityErrorBoundary } from "@/utils/entity-error-boundary.tsx";
import { z } from "zod";
import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/utils/page-title.ts";
import { RoutePending } from "@/components/custom/route-pending.tsx";

export const Route = createFileRoute("/_authenticated/settings/teams/$teamId")({
	loader: async ({ params, context: { queryClient } }) => {
		// Validate here (not in params.parse) so a malformed id throws inside
		// the loader, where the route's errorComponent catches it — param-parse
		// throws happen during matching and escape to the global boundary.
		z.uuid().parse(params.teamId);
		const team = await queryClient.ensureQueryData(
			teamQueryOptions(params.teamId),
		);

		return { team };
	},
	errorComponent: createEntityErrorBoundary({
		title: m.team_not_found_title,
		description: m.team_not_found_description,
		backLabel: m.team_not_found_back,
		backTo: "/settings/teams",
	}),
	head: ({ loaderData }) => ({
		meta: [
			{ title: pageTitle(loaderData?.team.name ?? m.team_detail_title()) },
		],
	}),
	component: RouteComponent,
	pendingComponent: RoutePending,
});

function RouteComponent() {
	return <TeamDetail />;
}
